export enum AssetStatusType {
  Publish = "Publish",
  Draft = "Draft",
}
